import Request from './common/Request';

class SemaphoreLocksApi {
    static getSemaphoreLocks() {
        return Request.get('/api/common/get-semaphore-locks');
    }

    static unlockSemaphore(semaphore) {
        return Request.get('/api/common/unlock-semaphore-lock/' + semaphore);
    }

    static unlockAllSemaphores() {
        return Request.get('/api/common/unlock-all-semaphore-locks');
    }
}

export default SemaphoreLocksApi;